import { Map } from 'immutable'
import { createReducer } from 'reducers/utils'
import {
  LOAD_FAST_FEATURE_STATUS_SUCCESS,
  TOGGLE_FAST_FEATURE_STATUS,
  TOGGLE_FAST_FEATURE_STATUS_SUCCESS,
  TOGGLE_FAST_FEATURE_STATUS_FAILURE,
  SAVE_FAST_FEATURE_DETAILS,
  SAVE_FAST_FEATURE_DETAILS_SUCCESS,
  SAVE_FAST_FEATURE_DETAILS_FAILURE,
} from 'actions/feature/fastFeatures'

export const initialState = Map({
  featureId: null,
  isFastFeature: false,
  isToggling: false,
  isSaving: false,
  error: null,
})

const handlers = {
  [LOAD_FAST_FEATURE_STATUS_SUCCESS]: (state, { payload }) =>
    state
      .set('featureId', payload.featureId)
      .set('isFastFeature', payload.isFastFeature)
      .set('error', null),

  [TOGGLE_FAST_FEATURE_STATUS]: (state) =>
    state.set('isToggling', true).set('error', null),

  [TOGGLE_FAST_FEATURE_STATUS_SUCCESS]: (state, { payload }) =>
    state
      .set('isFastFeature', payload.isFastFeature)
      .set('isToggling', false)
      .set('error', null),

  [TOGGLE_FAST_FEATURE_STATUS_FAILURE]: (state, { payload }) =>
    state.set('isToggling', false).set('error', payload.error),

  [SAVE_FAST_FEATURE_DETAILS]: (state) =>
    state.set('isSaving', true).set('error', null),

  [SAVE_FAST_FEATURE_DETAILS_SUCCESS]: (state) =>
    state.set('isSaving', false).set('error', null),

  [SAVE_FAST_FEATURE_DETAILS_FAILURE]: (state, { payload }) =>
    state.set('isSaving', false).set('error', payload.error),
}

export default createReducer(initialState, handlers)
